import { HsaFsaScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <HsaFsaScreen />;
}
